/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
import React, { useMemo } from 'react';
import useRenderResources from '../../../../../../hooks/Resource/useRenderResources';
import { currentSong } from '../../../../../../utils/reactiveVars';
import { formatResourceContent } from '../../../../../../utils/resource';
import TextModule from '../../Modules/TextModule';
import { useLocation } from 'react-router-dom';

const SongSummaryTeachingTips = () => {
  const {
    summary,
    teachingTips,
    songSummaryMedia,
    teachingTipsMedia,
    esongbooks,
  } = currentSong();

  const location = useLocation();

  const titles = useMemo(() => {
    const titles = ['Song Summary', 'Teaching tips'];

    const params = new URLSearchParams(location.search);
    const esongbookId = params.get('esongbookId');

    if (esongbooks.length === 1 && esongbooks[0].customSongpageHeading) {
      titles[0] = esongbooks[0].songSummaryCustomTitle || titles[0];
      titles[1] = esongbooks[0].teachingTipsCustomTitle || titles[1];
    } else if (esongbooks.length > 1 && esongbookId) {
      const selectedEsongBook = esongbooks.find(
        (elm) => elm.id === esongbookId
      );
      titles[0] =
        (selectedEsongBook?.customSongpageHeading &&
          selectedEsongBook?.songSummaryCustomTitle) ||
        titles[0];
      titles[1] =
        (selectedEsongBook?.customSongpageHeading &&
          selectedEsongBook?.teachingTipsCustomTitle) ||
        titles[1];
    }

    return titles;
  }, [esongbooks, location]);

  return (
    <>
      {summary || teachingTips ? (
        <div className="card__plain">
          <div
            className={`card__plain__body plus-padding bg__white ${
              formatResourceContent(teachingTipsMedia)?.length > 0 ? 'pb-0' : ''
            }`}
          >
            <div className="card__plain__content">
              {summary && <TextModule title={titles[0]} text={summary} />}
              {songSummaryMedia &&
                formatResourceContent(songSummaryMedia).map((medium) => (
                  <React.Fragment key={medium.key}>
                    {useRenderResources(medium)}
                  </React.Fragment>
                ))}
              {teachingTips && (
                <>
                  <TextModule title={titles[1]} text={teachingTips} list />
                  <div className="mt-n4" />
                </>
              )}
              {teachingTipsMedia &&
                formatResourceContent(teachingTipsMedia).map((medium) => (
                  <React.Fragment key={medium.key}>
                    {useRenderResources(medium)}
                  </React.Fragment>
                ))}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
export default SongSummaryTeachingTips;
